import { parseEcommerceProductId as parseId } from '@magalu/stereo-ui/utils';
export var parseEcommerceProductId = function parseEcommerceProductId(product) {
  return parseId(product);
};